import { IDatasource } from 'core-ts-types';
import { IInterface, IInterfaceDTD } from 'utility-js-interface';
import {
  IChoiceBuilderDTD,
  IPollBuilderDTD,
  IQuestionBuilderDTD,
  IQuestionXChoiceBuilderDTD,
  IQuestionXChoiceXResourceBuilderDTD,
  IResouseBuilderDTD
} from '../poll_interfaces';
import { IPollAnswerBuilderDTD } from './poll_answer_datastore';

export interface IPollDataStoreDTD {
  poll: IPollBuilderDTD;
  question: IQuestionBuilderDTD;
  choice: IChoiceBuilderDTD;
  resource: IResouseBuilderDTD;
  selected_resources: IResouseBuilderDTD;
  question_x_choice_x_resource: IQuestionXChoiceXResourceBuilderDTD;
  question_x_choice: IQuestionXChoiceBuilderDTD;
  show_results_page: boolean;
  answers?: IPollAnswerBuilderDTD;
}

export class PollDataStore implements IDatasource {
  id: string;
  store: IPollDataStoreDTD;

  constructor(private Interface: IInterface, private PollDataStoreDTD: IInterfaceDTD) {
    this.id = 'poll';
    this.store = {} as IPollDataStoreDTD;
  }

  write(data: any): PollDataStore {
    this.store = this.Interface.make(this.PollDataStoreDTD, data);
    return this;
  }

  initialize(): PollDataStore {
    this.store = this.Interface.generate(this.PollDataStoreDTD);
    return this;
  }

  read(): IPollDataStoreDTD {
    return this.store;
  }

  report(fn: (store: IPollDataStoreDTD) => any): any {
    return fn(this.store);
  }

  addBuiltQuestions(questions: any): any {
    return (this.store.question = questions);
  }

  answerQuestion(answer: any): any {
    return this.store.poll.answered_questions.push(answer);
  }

  addQuestionXChoice(questionXChoice: any): any {
    return (this.store.question_x_choice = questionXChoice);
  }
}

angular
  .module('capability-ng-poll')
  .constant('PollDataStoreDTD', {
    poll: {
      type: 'ngObject',
      typeDef: 'PollBuilder'
    },
    question: {
      type: 'ngObject',
      typeDef: 'QuestionBuilder'
    },
    choice: {
      type: 'ngObject',
      typeDef: 'ChoiceBuilder'
    },
    question_x_choice_x_resource: {
      type: 'ngObject',
      typeDef: 'QuestionXChoiceXResourceBuilder'
    },
    question_x_choice: {
      type: 'object'
    },
    resource: {
      type: 'object'
    },
    first_question_id: 'number'
  })
  .factory('ngPollDataStore', (Interface: IInterface, PollDataStoreDTD: IInterfaceDTD): PollDataStore => {
    return new PollDataStore(Interface, PollDataStoreDTD).initialize();
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/datastore/poll_datastore.ts